import { UI_SETTINGS_VIEW_PAGE_DEFAULT_SIZE } from "./view-page-default-size.const";

export function getUiSettingsDefaultPageSizes(): number[] {
    return [UI_SETTINGS_VIEW_PAGE_DEFAULT_SIZE, 24, 40, 120, 500]
} 